import apiSlice from "../api/apiSlice";
import { assignmentApi } from "../assignment/assignmentApi";
import { quizApi } from "../quiz/quizApi";

export const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    getVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
    addVideo: builder.mutation({
      query: (data) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: newVideo } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              return (draft = [...draft, newVideo]);
            })
          );
        } catch {}
      },
    }),
    editVideo: builder.mutation({
      query: ({ data, videoId }) => ({
        url: `/videos/${videoId}`,
        method: "PUT",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedVideo } = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              const targetedVideo = draft.find(
                (video) => video.id == updatedVideo.id
              );
              Object.assign(targetedVideo, updatedVideo);
            })
          );
        } catch {}
      },
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // update cache
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
            return draft.filter((video) => video.id != arg);
          })
        );
        try {
          await queryFulfilled;

          // Delete the corresponding assignment against the deleted video
          const assignments = await dispatch(
            assignmentApi.endpoints.getAssignments.initiate()
          ).unwrap();
          const targetedAssignment = assignments.find(
            (assignment) => assignment.video_id == arg
          );
          if (targetedAssignment?.id) {
            dispatch(
              assignmentApi.endpoints.deleteAssignment.initiate(
                targetedAssignment.id
              )
            );
          }

          //  remove the corresponding quizzes against the deleted video
          const quizzes = await dispatch(
            quizApi.endpoints.getQuizzesByVideoId.initiate(arg)
          ).unwrap();
          if (quizzes.length > 0) {
            quizzes.map((quiz) => {
              dispatch(quizApi.endpoints.deleteQuiz.initiate(quiz.id));
            });
          }
        } catch (err) {
          console.log(err);
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetVideoQuery,
  useGetVideosQuery,
  useAddVideoMutation,
  useEditVideoMutation,
  useDeleteVideoMutation,
} = videosApi;
